// Generated by Melange

import * as Buhta_cabinet__AdminIdentitiesSubHeader from "../../../components/molecules/AdminSidebar/AdminIdentitiesSubHeader.js";
import * as Buhta_cabinet__Btn from "../../../components/html/Btn.js";
import * as Buhta_cabinet__ControlAdmin from "../../../grpc/ControlAdmin.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../../ErrorPage.js";
import * as Buhta_cabinet__Field from "../../../components/html/Field.js";
import * as Buhta_cabinet__Identity from "../../../models/Identity.js";
import * as Buhta_cabinet__Link from "../../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../../util/ToastSender.js";
import * as Buhta_components__LoadingDiv from "../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import EyeClosedSvg from "static/icons/eye-closed.svg";
import EyeOpenedSvg from "static/icons/eye-opened.svg";

function IdentitySecurityPage(Props) {
  let openMenu = Props.openMenu;
  const match = React.useState(function () {
        return "";
      });
  const setNewPassword = match[1];
  const newPassword = match[0];
  const match$1 = React.useState(function () {
        return true;
      });
  const setNewPasswordHidden = match$1[1];
  const newPasswordHidden = match$1[0];
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const match$2 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$2[1];
  const match$3 = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match$3[0];
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  let identityId;
  if (typeof currentRoute === "number" || currentRoute.TAG !== /* Admin */7) {
    identityId = "";
  } else {
    const match$4 = currentRoute._0;
    if (typeof match$4 === "number" || match$4.TAG !== /* Identities */2) {
      identityId = "";
    } else {
      const match$5 = match$4._0;
      identityId = typeof match$5 === "number" || match$5._1 !== 1 ? "" : match$5._0;
    }
  }
  const match$6 = Buhta_cabinet__Identity.use(undefined);
  const identity = match$6[0];
  const emptyProfile = {
    id: 0,
    email: "",
    phone: "",
    first_name: "",
    last_name: "",
    userpic_url: "",
    tenants: /* [] */0,
    create_time: undefined
  };
  let profile;
  if (typeof identity === "string" || identity.NAME !== "Data") {
    profile = emptyProfile;
  } else {
    const profile$1 = identity.VAL.profile;
    profile = profile$1 !== undefined ? profile$1 : emptyProfile;
  }
  const subheader = JsxRuntime.jsx(Buhta_cabinet__AdminIdentitiesSubHeader.make, {
        currentRoute: currentRoute,
        identityId: identityId
      });
  let tmp;
  if (typeof identity === "string") {
    tmp = JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {});
  } else if (identity.NAME === "Data") {
    const profile$2 = identity.VAL.profile;
    const profile$3 = profile$2 !== undefined ? profile$2 : ({
          id: 0,
          email: "",
          phone: "",
          first_name: "",
          last_name: "",
          userpic_url: "",
          tenants: /* [] */0,
          create_time: undefined
        });
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("img", {
                  className: "w-5 h-5",
                  src: StaticAsset.src("/static/icons/back-arrow.svg")
                }),
            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                  className: "ml-4 text-white",
                  children: profile$3.first_name + (" " + profile$3.last_name)
                })
          ],
          className: "flex items-center"
        });
  } else {
    console.log(identity.VAL);
    tmp = JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {});
  }
  const headerMobile = JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                              route: {
                                TAG: /* Admin */7,
                                _0: {
                                  TAG: /* Identities */2,
                                  _0: /* List */0
                                }
                              },
                              className: " flex justify-between",
                              children: tmp
                            }),
                        className: "flex items-center gap-2"
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                className: "border-l border-asphalt-dark h-5"
                              }),
                          JsxRuntime.jsx("button", {
                                children: JsxRuntime.jsx("img", {
                                      className: "w-6 h-6",
                                      src: StaticAsset.src("/static/icons/menu-white-24.svg")
                                    }),
                                onClick: openMenu
                              })
                        ],
                        className: "flex items-center gap-2"
                      })
                ],
                className: "h-14 bg-black flex justify-between px-4"
              }),
          subheader
        ],
        className: "flex flex-col"
      });
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Безопасноть"
      });
  return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
              header: deviceType === "mobile" ? headerMobile : header,
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                  className: "text-default-gray",
                                  children: "Смена пароля"
                                }),
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_cabinet__Field.make, {
                                          label: "Новый пароль",
                                          type_: newPasswordHidden ? "password" : "text",
                                          name: "newPassword",
                                          required: true,
                                          onChange: (function (value) {
                                              Curry._1(setNewPassword, (function (param) {
                                                      return value;
                                                    }));
                                            }),
                                          autoComplete: "off",
                                          value: newPassword
                                        }),
                                    JsxRuntime.jsx("button", {
                                          children: newPasswordHidden ? JsxRuntime.jsx(EyeClosedSvg, {}) : JsxRuntime.jsx(EyeOpenedSvg, {}),
                                          className: "absolute right-4 top-4",
                                          tabIndex: -1,
                                          type: "button",
                                          onClick: (function (param) {
                                              Curry._1(setNewPasswordHidden, (function (param) {
                                                      return !newPasswordHidden;
                                                    }));
                                            })
                                        })
                                  ],
                                  className: "relative mt-3"
                                }),
                            JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                                  title: "Сохранить",
                                  onClick: (function (param) {
                                      const updateData_family_name = profile.last_name;
                                      const updateData_given_name = profile.first_name;
                                      const updateData_email = profile.email;
                                      const updateData_phone = profile.phone;
                                      const updateData_password = newPassword;
                                      const updateData = {
                                        family_name: updateData_family_name,
                                        given_name: updateData_given_name,
                                        email: updateData_email,
                                        phone: updateData_phone,
                                        userpic_id: undefined,
                                        password: updateData_password
                                      };
                                      const __x = Buhta_cabinet__ControlAdmin.AdminIdentityService.update(tenant, identityId, updateData);
                                      $$Promise.get(__x, (function (result) {
                                              if (result.TAG === /* Ok */0) {
                                                return Curry._1(dispatchToasts, {
                                                            TAG: /* Add */0,
                                                            _0: {
                                                              id: Buhta_core__Toast.generateId(undefined),
                                                              text: "Настройки сохранены",
                                                              kind: "success",
                                                              onClick: (function (param) {
                                                                  
                                                                })
                                                            }
                                                          });
                                              } else {
                                                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении");
                                              }
                                            }));
                                    }),
                                  className: "mt-4 w-full py-3"
                                })
                          ],
                          className: "bg-white lg:w-140.5 w-full px-10 py-6 mt-6 rounded shadow-card "
                        }),
                    className: "w-full flex flex-col items-center px-4"
                  }),
              className: "bg-gray-pale"
            });
}

const make = IdentitySecurityPage;

export {
  make ,
}
/* Buhta_cabinet__AdminIdentitiesSubHeader Not a pure module */
